import { useCallback, useContext, useState } from 'react';
import { isRawString, safeGetValue } from '../utils';
import { ModelContext } from '../providers/ModelProvider';
export const useFieldValue = (propertyPath) => {
    const { model, errors, onPropertyChange, disabled } = useContext(ModelContext);
    const propertyName = propertyPath.replace('#.', '');
    const propertyErrors = errors === null || errors === void 0 ? void 0 : errors[propertyPath];
    const value = safeGetValue(model, propertyName);
    const [isRaw, setIsRaw] = useState(isRawString(value));
    const onChange = useCallback((newValue) => {
        setIsRaw(isRawString(newValue));
        onPropertyChange(propertyName, newValue);
    }, [onPropertyChange, propertyName]);
    return {
        value,
        errors: propertyErrors,
        disabled,
        isRaw,
        onChange,
    };
};
//# sourceMappingURL=field-value.js.map